<template>
  <FullScreen>
    <div class="flex flex-col items-center m-auto" style="width: 30%;">
      <payment-success-icon></payment-success-icon>
      <div class="mt-10 mb-5 text-center">
        <h1>Verifikasi Email Berhasil</h1>
        <div class="mt-5">
          <p style="line-height: 22px!important;">Alhamdulillah email anda telah berhasil terverifikasi,
Sekarang anda dapat mulai memakai situs kami secara keseluruhan</p>
        </div>
      </div>
      <div class="mb-5">
        <va-button type="primary" @click.prevent="goBack()">Ke Halaman Utama</va-button>
      </div>
      <a class="th-hover-underline" href="#" @click.prevent="goback">Kembali</a>
    </div>
  </FullScreen>
</template>

<script>
const FullScreen = () => import('@/components/App/FullScreen')
const PaymentSuccessIcon = () => import('@/components/Icon/PaymentSuccess')

export default {
  data() {
    return {
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'Utama' })
    },
  },
  components: { FullScreen, PaymentSuccessIcon },
  mounted() {
    const urlString = window.location.href
    const url = new URL(urlString)
    const token = url.searchParams.get('token')
    this.$store.dispatch('user/VERIFYING_EMAIL', { token })
  },
}
</script>

<style>

</style>
